// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"2b0df50d","302":"14fee610","453":"965888c2","754":"57fffda1"}[chunkId] + ".chunk.js";
};